<template>
  <div class="GraphTitle-FAQ">
    <h2 class="fit20-font-light">{{ $t('totalProgress') }}</h2 >
    <SelectList :eventName="'change-session'" @change-session="$emit('change-session', $event)" />
  </div>
</template>

<script>
// import { selectSessions } from '../actions/onloadActions';
import SelectList from './SelectSessionsList';
export default {
  name: 'GraphTitleFAQ',
  components: { SelectList },
  props: ['totalSessions', 'sessions'],

  // data() {
  //   return {
  //     selected: {},
  //   };
  // },
  mounted() {
    // this.selected = selectSessions(this.sessions);
    // console.log('this.totalSessions: ' + this.totalSessions);
    this.$emit('change-session', 25);
  },
};
</script>

<style>
.GraphTitle-FAQ {
  color: #009fe3;
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
  border-bottom: 2px solid #a3cc21;
  margin-bottom: 10px;
}
</style>
